/**
 * Social media URLs — single source of truth.
 *
 * Add or change a URL here and it propagates everywhere the
 * `<SocialLinks />` component is rendered (footer today; can be
 * dropped into a press kit, /about page, or email signature later).
 *
 * Rules:
 *   - Empty string = the icon is hidden entirely.
 *   - URLs MUST start with `http://` or `https://` — we use them
 *     verbatim in the anchor `href`. Bare handles like "@LeagueHub"
 *     will not work.
 *   - Order of keys in this object = render order in the UI.
 *
 * Brand names are the lowercase property keys so the icon lookup
 * stays trivial (no aliasing).
 */
const SOCIALS = {
  instagram: "http://instagram.com/leaguehubdotco",
  twitter:   "http://twitter.com/leaguehubdotco",
  youtube:   "https://www.youtube.com/@LeagueHubdotco",
  tiktok:    "",   // not yet — leave blank to hide
  facebook:  "https://www.facebook.com/leaguehub/about/",
};

/** Lowercase keys whose URL is a non-empty http(s) URL. */
export function activeSocials() {
  return Object.entries(SOCIALS)
    .filter(([, url]) => typeof url === "string" && /^https?:\/\//i.test(url))
    .map(([name, url]) => ({ name, url }));
}

export default SOCIALS;
